import React from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <div className="footer padded-sec"> 
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-xl-3 col-lg-6 col-sm-6 col-xs-12'>
              <Link to="/"><div className='ftr-logo'> 
                <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/ftr-logo.png" alt="SPCSH" /> </LazyLoad>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.253538576462!2d77.35474387610385!3d28.411605594077844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cdd21a4b1c9c9%3A0x434559132d3df62a!2sSt.%20Peter%E2%80%99s%20Convent%20School%20sec%2088%2C%20Greater%20Faridabad.!5e0!3m2!1sen!2sin!4v1744785486711!5m2!1sen!2sin" width="100%" height="150px" frameborder="0" allowfullscreen=""></iframe>

              </div>
              </Link>
            </div> 
            <div className='col-xl-2 col-lg-6 col-sm-6 col-xs-12'>
              <h3>Quick Links</h3>
              <div className='quick-link'>
                <ul>
                  <li><Link to="/AboutUs"><i className="bi bi-caret-right-fill"></i> About Us</Link></li>
                  <li><Link to="/ContactUs"><i className="bi bi-caret-right-fill"></i>Contact Us </Link></li>
                  <li><Link to="/ErpSoftware"><i className="bi bi-caret-right-fill"></i>ERP Software</Link></li>
                  <li><Link to="https://portalguidelines.campuscare.info/index.html#SPCSFBD" target="_blank"><i className="bi bi-caret-right-fill"></i> Portal (Help?)</Link></li>
                  <li><Link to="#" target="_blank"><i className="bi bi-caret-right-fill"></i>Online Fee Payment</Link></li>
                  <li><Link to="/Tc"><i className="bi bi-caret-right-fill"></i>Transfer Certificate</Link></li>
                </ul>
              </div>
            </div>
            <div className='col-xl-3 col-lg-6 col-sm-6 col-xs-12 address'>
              <h3>Get In Touch</h3>
              <p><i className="bi bi-house-door-fill"></i> <span><Link to="https://maps.app.goo.gl/rA6bBrHvTDtX4qAt5" target="_blank">St. Peter’s Convent School, Sec-88, Greater Faridabad, Haryana - 121002</Link></span></p>
              <p><i className="bi bi-telephone-fill"></i> <span><a href="tel:+91-9560356167">+91-9560356167,</a> <a href="tel:+91 7065054701"> +91 7065054701</a></span></p>
              <p><i className="bi bi-envelope-fill"></i> <span> <a href="mailto:spetercsfbd@gmail.com">spetercsfbd@gmail.com</a></span></p>
              <div className="col-lg-5 col-md-6 col-sm-6">
              <ul className='socialMedia'>   
                 <li><Link to="/" target="_blank"><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/instagram.png" alt="STPCSH" /></Link></li>
                 <li><Link to="/" target="_blank"><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facebook.png" alt="STPCSH" /></Link></li>
                 <li><Link to="/" target="_blank"><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/yt.png" alt="STPCSH" /></Link></li>
                 <li><Link to="/" target="_blank"><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/linkiend.png" alt="STPCSH" /></Link></li>
            </ul>
              </div>
              </div>
            <div className='col-xl-4 col-lg-6 col-sm-6 col-xs-12'>
              <div className='ph-flex'>
                <div className="app-cont">
                  <h3>Download Mobile App</h3>
                  <p>  CampusCare 10x mobile app for parents is a tool that serves as a single point of reference for parents. The app centralises all the school-parent interaction and lets parents stay updated with their ward's day-to-day activities. Parents can receive assignments, homework, and circulars, keep track of their child's attendance, do online fee payment, view report cards.</p>
                  <div>
                    <a href="https://apps.apple.com/in/app/campuscare-10x/id1611283814" target="_blank">
                      <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/apple.png" className="img-fluid" /></LazyLoad>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.entab.learninglab&amp;hl=en-IN" target="_blank">
                      <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/playstore.png" className="img-fluid" /></LazyLoad>
                    </a>
                  </div>
                  <p className="link"><Link to="#" target="_blank">School Code : SPCSFBD</Link></p>
                </div>
                <div className='mobile-icon'>
                  <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/mobile-icon.png" className="img-fluid" /></LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='copyright'>
        ©️ Copyright 2025 by  St. Peter’s Convent School, Faridabad Created by  <Link to="https://www.entab.in/" target="_blank">Entab Infotech: CampusCare®️ </Link>
      </div>
    </>
  );
}

export default Footer;
